import React, { useEffect, useRef, useState } from "react";
import { FiCheck, FiAlertCircle, FiInfo, FiAlertTriangle, FiX } from "react-icons/fi";

const variants = {
  success: {
    title: "U krye",
    icon: FiCheck,
    iconWrap: "bg-emerald-500 text-white",
    bar: "bg-emerald-500",
  },
  error: {
    title: "Gabim",
    icon: FiAlertCircle,
    iconWrap: "bg-red-500 text-white",
    bar: "bg-red-500",
  },
  warning: {
    title: "Kujdes",
    icon: FiAlertTriangle,
    iconWrap: "bg-amber-500 text-white",
    bar: "bg-amber-500",
  },
  info: {
    title: "Njoftim",
    icon: FiInfo,
    iconWrap: "bg-sky-600 text-white",
    bar: "bg-sky-600",
  },
};

function asText(message) {
  if (message == null || message === "") return "";
  if (typeof message === "string") return message;
  if (typeof message === "object") {
    const text = message.message || message.Message || message.title || message.Title;
    if (typeof text === "string" && text.trim()) return text;
  }
  return "Diçka shkoi keq. Provoni përsëri.";
}

const Notification = ({ type = "info", message, visible, onClose, duration = 1400 }) => {
  const text = asText(message);
  const [cycle, setCycle] = useState(0);
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!visible || !text) return undefined;
    setCycle((current) => current + 1);
    const timer = setTimeout(() => onCloseRef.current?.(), duration);
    return () => clearTimeout(timer);
  }, [visible, text, duration]);

  if (!visible || !text) return null;

  const style = variants[type] || variants.info;
  const Icon = style.icon;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-5 z-[100] flex justify-center px-4" role="status">
      <div className="pointer-events-auto w-full max-w-lg animate-toast-in overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl">
        <div className="flex items-center gap-4 px-4 py-4">
          <span className={`inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full ${style.iconWrap}`}>
            <Icon size={22} aria-hidden />
          </span>
          <div className="min-w-0 flex-1">
            <p className="text-base font-semibold text-slate-900">{style.title}</p>
            <p className="mt-0.5 text-base leading-snug text-slate-700">{text}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 rounded-full p-1.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
            aria-label="Mbyll njoftimin"
          >
            <FiX size={18} />
          </button>
        </div>
        <div className="h-1 bg-slate-100">
          <div
            key={cycle}
            className={`h-full origin-left ${style.bar}`}
            style={{ animation: `toast-timer ${duration}ms linear forwards` }}
          />
        </div>
      </div>
    </div>
  );
};

export default Notification;
